import "./qrCodeLandingPage.scss";

import moment from "moment";
import pluralize from "pluralize";
import StoreDetails from "./StoreDetails";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import ProfileDetails from "./ProfileDetails";
import { useLocation } from "react-router-dom";
import AllStoresCanvas from "./AllStoresCanvas";
import React, { useEffect, useState } from "react";
import Loading from "../../../../../../common/Loading";
import Phone02 from "../../../../../../assets/Phone02";
import LoyaltyShortlinkPage from "./LoyaltyShortlinkPage";
import Button from "../../../../../../common/Buttons/Button";
import Typography from "../../../../../../common/Typography";
import Input from "../../../../../../common/TextFields/Input";
import Slider3 from "../../../../../../common/Slider/Slider3";
import SbAccordion from "../../../../../../common/SbAccordion";
import isEmpty from "../../../../../../../utils/constants/isEmpty";
import { isAdvancedCashback } from "../../../../Loyalty/Edit/utils";
import AskProfileDetails from "./AskProfileDetails/AskProfileDetails";
import ArrowNarrowLeft from "../../../../../../assets/ArrowNarrowLeft";
import CheckVerified03 from "../../../../../../assets/CheckVerified03";
import { loyaltyMembShortlinkTabs } from "../../../../Membership/utils";
import InfoCircleFilled from "../../../../../../assets/InfoCircleFilled";
import CalendarCheck02Filled from "../../../../../../assets/CalendarCheck02Filled";
import TabSelectButtonGroup from "../../../../../../common/Buttons/TabSelectButtonGroup";
import { getSubscribedMembershipsRewards } from "../../../../../../../redux/actions/shortlinkActions";
import SubscribedMemberships from "../../../../Membership/Components/LandingPage/SubscribedMemberships";
import LoyaltyFinalCreative from "../../../../Loyalty/Edit/components/LandingPages/LoyaltyFinalCreative";
import AdvancedLoyaltyFinalCreative from "../../../../Loyalty/Edit/components/LandingPages/AdvancedLoyaltyFinalCreative";
import {
  scanQrCustomer,
  getPublicLoyalty,
  checkCustomerRewards,
  checkProfileCompletionStatus,
} from "../../../../../../../redux/actions/qrCodeActions";

const defaultCustomerName = "customer_name_not_exists_719382";

const QrCodeLandingPage = ({
  subsMembs = [],
  qrCodeData,
  countryCode,
  currencyView,
  customerDetails = {},
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(location.search);

  const [isAllStores, setIsAllStores] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);

  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [responseObj, setResponseObj] = useState({});
  const [loyaltyData, setLoyaltyData] = useState({});
  const [isLoading, toggleLoading] = useState(false);
  const [profileData, setProfileData] = useState("");
  const [secondPageStatus, setSecondPageStatus] = useState(""); // claimed, already_claimed, for_new_customer_only, incomplete-profile, profile-already-completed
  const [isConfirmationPage, setConfirmationPage] = useState(false);
  const [customerRewardsData, setCustomerRewardsData] = useState({});

  const [isLoadingMemberships, toggleLoadingMemberships] = useState(false);
  const [isShowLoyaltyAndMembTabs, showLoyaltyAndMembTabs] = useState(false);
  const [activeTabForLoyaltyAndMemb, setActiveTabForLoyaltyAndMemb] =
    useState("loyalty"); // loyalty, membership

  const isBirthdayAnniversaryObjective =
    qrCodeData?.template?.objective?.key ===
    "get_customer_birthday_anniversary";

  const isCheckCustRewardsObjective =
    qrCodeData?.template?.objective?.key === "check_customer_rewards";

  const isCache = query.get("cache");
  const isIncompleteProfile = secondPageStatus === "incomplete-profile";
  const isProfileCompleted = secondPageStatus === "profile-already-completed";

  let data = {
    qrId: qrCodeData?.id,
    terms: qrCodeData?.terms || "",
    storeName: qrCodeData?.entity_id?.name || "",
    logo: qrCodeData?.landing_page_settings?.logo || "",
    title: qrCodeData?.landing_page_settings?.title || "",
    successPageTitle:
      qrCodeData?.landing_page_settings?.success_page_title || "",
    sources: qrCodeData?.landing_page_settings?.sources || [],
    text_color: qrCodeData?.landing_page_settings?.colors?.text || "#ffffff",
    theme_color: qrCodeData?.landing_page_settings?.colors?.theme || "#038C8B",

    rewardType: qrCodeData?.reward?.type || "",
    min_bill: qrCodeData?.reward?.settings?.min_bill || "",
    isAllStores: qrCodeData?.entity_type === "Group" || false,
    allStoresArr: qrCodeData?.reward?.redemption?.applicable_stores || [],
    expiryDuration: qrCodeData?.reward?.expires_in?.duration,
    expiryPeriod: qrCodeData?.reward?.expires_in?.period,
    isMultipleRedemptions:
      qrCodeData?.reward?.redemption?.redemption_per_customer === "multiple",
    storeWiseItemsList: qrCodeData?.reward?.items || [],
  };

  useEffect(() => {
    const isStore = qrCodeData?.entity_type === "Store";
    const loyaltyFetchNeeded =
      isStore ||
      qrCodeData?.reward?.redemption?.applicable_stores?.length === 1;
    const isWaCacheQR =
      isCache && qrCodeData?.collect_customer_details?.via_whatsapp?.is_active;
    const scanFetchNeeded =
      qrCodeData?.id && (isWaCacheQR || !isEmpty(customerDetails));

    if (!customerName && !isEmpty(customerDetails))
      setCustomerName(customerDetails?.name);

    const isCustomerNameNotExist =
      qrCodeData?.audience === "new" &&
      qrCodeData?.status === "active" &&
      !customerDetails?.name;

    const fetchLoyalty = () => {
      // fetch loyalty data and set locally
      const storeId = isStore
        ? qrCodeData?.entity_id?.id
        : qrCodeData?.reward?.redemption?.applicable_stores?.[0]?.id;
      return dispatch(getPublicLoyalty(storeId)).then((payload) => {
        setLoyaltyData(payload);
      });
    };

    const fetchQrScanData = () => {
      const data = {
        country_code: countryCode,
        name:
          isCustomerNameNotExist ||
          qrCodeData?.status === "draft" ||
          qrCodeData?.status === "inactive"
            ? defaultCustomerName
            : customerDetails?.name,
        mobile: customerDetails?.phone,
      };
      return dispatch(scanQrCustomer(qrCodeData?.id, data, isCache)).then(
        (payload) => {
          setConfirmationPage(true);
          setResponseObj(payload?.responseObj ?? payload);
          setSecondPageStatus(payload?.res_type);
          data.allStoresArr =
            payload?.responseObj?.applicableStores ?? payload?.applicableStores;
        }
      );
    };

    if (loyaltyFetchNeeded || scanFetchNeeded) {
      toggleLoading(true);
      const promiseArr = [];
      if (loyaltyFetchNeeded) promiseArr.push(fetchLoyalty());
      if (scanFetchNeeded) promiseArr.push(fetchQrScanData());

      Promise.all(promiseArr)
        .then(() => toggleLoading(false))
        .catch(() => toggleLoading(false));
    }
  }, [qrCodeData, customerDetails]);

  const handleClaim = () => {
    const trimmedName = customerName?.trim();
    const trimmedPhone = customerPhone?.trim();
    if (
      trimmedName.length === 0 &&
      !(isBirthdayAnniversaryObjective || isCheckCustRewardsObjective)
    ) {
      toastr.error("Validation Error", "User Name can not be empty");
      return;
    }

    if (trimmedPhone.length < 6) {
      toastr.error(
        "Validation Error",
        "Mobile number should have more than 6 digits."
      );
      return;
    }

    if (
      qrCodeData?.id &&
      trimmedPhone?.length > 6 &&
      (trimmedName?.length > 0 ||
        isCheckCustRewardsObjective ||
        isBirthdayAnniversaryObjective)
    ) {
      const data1 = {
        name: trimmedName,
        mobile: trimmedPhone,
        country_code: countryCode,
      };
      setSubmitting(true);
      dispatch(scanQrCustomer(qrCodeData?.id, data1, isCache))
        .then((payload) => {
          setSubmitting(false);
          setConfirmationPage(true);
          setResponseObj(payload?.responseObj);
          setSecondPageStatus(payload?.res_type);
          data.allStoresArr = payload?.responseObj?.applicableStores;
        })
        .catch(() => setSubmitting(false));
    }
  };

  const checkCustProfileStatus = () => {
    const trimmedPhone = customerPhone?.trim();
    if (trimmedPhone.length < 6) {
      toastr.error(
        "Validation Error",
        "Mobile number should have more than 6 digits."
      );
      return;
    }
    const data = {
      phone: trimmedPhone,
      country_code: countryCode,
    };
    setSubmitting(true);
    dispatch(checkProfileCompletionStatus(qrCodeData?.entity_id?.id, data))
      .then((data) => {
        if (data?.is_customer_profile_completed) {
          setSecondPageStatus("profile-already-completed");
        } else {
          setSecondPageStatus("incomplete-profile");
        }
        setProfileData(data);
        setSubmitting(false);
      })
      .catch(() => setSubmitting(false));
  };

  const fetchSubscribedMembership = (customerId, entityId) => {
    if (!customerId || !entityId) return;

    const query = {
      entityId,
      customerId,
    };

    toggleLoadingMemberships(true);
    dispatch(getSubscribedMembershipsRewards(query))
      .then((payload) => {
        toggleLoadingMemberships(false);
        if (payload?.length > 0) showLoyaltyAndMembTabs(true);
      })
      .catch(() => toggleLoadingMemberships(false));
  };

  const handleCheckCustomerRewards = () => {
    const trimmedPhone = customerPhone?.trim();
    if (trimmedPhone.length < 6) {
      toastr.error(
        "Validation Error",
        "Mobile number should have more than 6 digits."
      );
      return;
    }
    const data = {
      phone: trimmedPhone,
      country_code: countryCode,
    };
    setSubmitting(true);
    dispatch(checkCustomerRewards(qrCodeData?.entity_id?.id, data))
      .then((data) => {
        if (data?.message) toastr.info(data?.message);
        else setCustomerRewardsData(data);
        setSubmitting(false);
        fetchSubscribedMembership(
          data?.customer?.id,
          qrCodeData?.entity_id?.group ?? qrCodeData?.entity_id?.id
        );
      })
      .catch(() => setSubmitting(false));
  };

  const pointsObj = {
    ...responseObj?.current_points,
    order_value: responseObj?.order_value,
    lifetime_spent: responseObj?.lifetime_spent,
  };
  const isShowRedeemCard = pointsObj?.current_points > 0;
  const pointsBranding = loyaltyData?.settings?.points_branding;
  const totalRedeemableRewards = loyaltyData?.rewards?.filter(
    (reward) =>
      reward?.is_active && reward?.points_value <= pointsObj?.current_points
  )?.length;
  const isAdvCbCreative =
    loyaltyData?.type === "cashback" &&
    isAdvancedCashback(loyaltyData?.settings?.advanced_cashback?.type);

  const confirmPageData = {
    icon:
      secondPageStatus === "claimed" ||
      (!isEmpty(customerDetails) && secondPageStatus === "already_claimed") ? (
        <CheckVerified03 height={48} width={48} color={data?.text_color} />
      ) : (
        <InfoCircleFilled
          size={44}
          rotate={180}
          color={data?.theme_color}
          bgcolor={data?.text_color}
        />
      ),
    title:
      secondPageStatus === "claimed" ||
      (!isEmpty(customerDetails) && secondPageStatus === "already_claimed")
        ? data?.successPageTitle ||
          (data?.rewardType === "loyalty"
            ? `Awesome ${customerName}! You've claimed your ${
                qrCodeData?.reward?.loyalty_bonus
              } ${pluralize(
                pointsBranding?.active ? pointsBranding?.name : "points",
                qrCodeData?.reward?.loyalty_bonus
              )}`
            : `Awesome ${customerName}! You've claimed your reward`)
        : secondPageStatus === "already_claimed"
        ? "You've already claimed this reward"
        : secondPageStatus === "for_new_customer_only"
        ? `This reward is only for new customers${
            data?.rewardType === "loyalty"
              ? ", You're already part of our loyalty program 😍"
              : ""
          } `
        : secondPageStatus === "inactive_qr_code"
        ? "This QR Code is no longer active"
        : secondPageStatus === "profile-already-completed"
        ? "Looks like we already have your details"
        : "",
    subtitle:
      secondPageStatus === "profile-already-completed"
        ? "This reward is only for those with incomplete profiles"
        : "",
  };

  const isQrCodeExpired = moment(responseObj?.expiryDate).isBefore(moment());

  return !isEmpty(customerRewardsData) ? (
    <>
      {activeTabForLoyaltyAndMemb === "loyalty" ? (
        <LoyaltyShortlinkPage
          data={customerRewardsData}
          currencyView={currencyView}
          allStoresArr={data?.allStoresArr}
          entityId={qrCodeData?.entity_id?.id}
        />
      ) : activeTabForLoyaltyAndMemb === "membership" ? (
        <SubscribedMemberships
          subscribedMemberships={subsMembs}
          customerId={customerRewardsData?.customer?.id}
          showLoyaltyAndMembTabs={showLoyaltyAndMembTabs}
        />
      ) : (
        <></>
      )}
      {!isLoadingMemberships &&
        isShowLoyaltyAndMembTabs &&
        subsMembs?.length > 0 && (
          <TabSelectButtonGroup
            tabList={loyaltyMembShortlinkTabs}
            activeTab={activeTabForLoyaltyAndMemb}
            extraClass="loyalty-membership-switch-tabs"
            setActiveTab={setActiveTabForLoyaltyAndMemb}
          />
        )}
    </>
  ) : isIncompleteProfile ? (
    <AskProfileDetails
      qrId={qrCodeData?.id}
      customerData={profileData}
      countryCode={countryCode}
      customerPhone={customerPhone}
      setResponseObj={setResponseObj}
      setSecondPageStatus={setSecondPageStatus}
      setConfirmationPage={setConfirmationPage}
    />
  ) : !isEmpty(customerDetails) && isEmpty(responseObj) ? (
    <Loading />
  ) : (
    <div
      className="qr-landing-page"
      style={{
        color: data.text_color,
        backgroundColor: data.theme_color,
      }}
    >
      <div
        className="main-header"
        style={{
          color: data.text_color,
          backgroundColor: data.theme_color,
        }}
      >
        <div className="background-icons"></div>
        {isConfirmationPage || isProfileCompleted ? (
          <>
            {confirmPageData.icon}
            <Typography
              weight="medium"
              size="display-xl"
              customClass="reward-claimed-greet"
              style={{ color: data.text_color }}
            >
              {confirmPageData.title}
            </Typography>
            {confirmPageData?.subtitle && (
              <Typography
                size="text-md"
                style={{ color: data.text_color, marginTop: "12px" }}
              >
                {confirmPageData.subtitle}
              </Typography>
            )}
            {responseObj?.expiryDate && (
              <div className="expiry-details">
                <Typography size="text-md" style={{ color: data.text_color }}>
                  Redeem it before it expires!
                </Typography>
                <div className="expiry-date">
                  <div className="deadline-logo">
                    <CalendarCheck02Filled />
                  </div>
                  <Typography size="text-md" style={{ color: data.text_color }}>
                    {isQrCodeExpired ? "Expired on" : "Expires on"}{" "}
                    <b>{moment(responseObj?.expiryDate).format("Do MMM'YY")}</b>{" "}
                  </Typography>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <Typography
              weight="medium"
              customClass="main-heading"
              style={{ color: data.text_color }}
            >
              {data.title}
            </Typography>
            {data.isMultipleRedemptions && (
              <p style={{ color: data.text_color, margin: "8px 0  0" }}>
                Redeem multiple times
              </p>
            )}
            <StoreDetails storeNameTxtColor={data.text_color} data={data} />
          </>
        )}
      </div>
      <div className="user-form">
        {isConfirmationPage || isProfileCompleted ? (
          <div className="confirmation-body">
            <StoreDetails storeNameTxtColor={"#0e1b1b"} data={data} />
            {isConfirmationPage && (
              <>
                {data.isAllStores && data.allStoresArr?.length > 1 ? (
                  <>
                    {secondPageStatus === "for_new_customer_only" ? (
                      <div className="can-still-visit">
                        <Typography size="text-sm">
                          You can still visit our other stores
                        </Typography>
                        <Button
                          isPlain={true}
                          fullWidth={true}
                          text="View all stores"
                          handleClick={() => setIsAllStores(!isAllStores)}
                          rightIcon={
                            <ArrowNarrowLeft color="#0d9298" rotate={180} />
                          }
                        />
                      </div>
                    ) : data.rewardType === "loyalty" ? (
                      <div className="loyalty-current-points">
                        <p>
                          You've total{" "}
                          <b>
                            {responseObj?.current_points?.current_points} points
                          </b>{" "}
                          🎉
                        </p>
                        <p style={{ marginBottom: "4px" }}>
                          Redeem your loyalty rewards at{" "}
                          {data?.allStoresArr?.length} stores.
                        </p>
                        <div
                          className="all-store-link"
                          onClick={() => setIsAllStores(!isAllStores)}
                        >
                          View all stores and rewards{" "}
                          <img
                            src="/assets/icons/right-dark-arrow.svg"
                            alt="view"
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="for-group-qr">
                        <Typography size="text-sm">
                          Redeem this reward at all stores
                        </Typography>
                        <Button
                          isPlain={true}
                          fullWidth={true}
                          text="View all stores"
                          handleClick={() => setIsAllStores(!isAllStores)}
                          rightIcon={
                            <ArrowNarrowLeft color="#0d9298" rotate={180} />
                          }
                        />
                      </div>
                    )}
                  </>
                ) : data.rewardType === "loyalty" ? (
                  <div className="qr-for-store-only">
                    {loyaltyData?.type === "cashback" &&
                    pointsObj?.current_points ? (
                      <div className="total-cashback-in-store">
                        <p>
                          You have{" "}
                          <span>
                            {" "}
                            {!pointsBranding?.active ? currencyView : ""}
                            {pointsObj?.current_points}{" "}
                            {pointsBranding?.active
                              ? pluralize(
                                  pointsBranding?.name,
                                  pointsObj?.current_points
                                )
                              : "cashback"}
                          </span>
                        </p>
                      </div>
                    ) : (
                      <>
                        {isShowRedeemCard && (
                          <>
                            {totalRedeemableRewards > 0 ? (
                              <div className="qr-redeemable-reward-div">
                                <div className="show-available-points">
                                  <span>Hello {customerName},</span>
                                  <span>
                                    You have{" "}
                                    <b>
                                      {pointsObj?.current_points}{" "}
                                      {pluralize(
                                        pointsBranding?.active
                                          ? pointsBranding?.name
                                          : "points",
                                        pointsObj?.current_points
                                      )}
                                    </b>
                                  </span>
                                </div>

                                <div className="show-total-rewards">
                                  <img
                                    src="/assets/images/qr/others/unlock.svg"
                                    alt="unlock"
                                  />
                                  <span>
                                    {totalRedeemableRewards}{" "}
                                    {pluralize(
                                      "Rewards",
                                      totalRedeemableRewards
                                    )}{" "}
                                    Unlocked 🎉
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <div className="qr-non-redeemable-rewards-div">
                                <p>
                                  You're{" "}
                                  <b>
                                    {loyaltyData?.rewards?.[0]?.points_value -
                                      pointsObj?.current_points}{" "}
                                    {pluralize(
                                      pointsBranding?.active
                                        ? pointsBranding?.name
                                        : "points",
                                      pointsObj?.current_points
                                    )}
                                  </b>{" "}
                                  away from your first reward
                                </p>
                                {pointsObj?.current_points <=
                                  loyaltyData?.rewards?.[0]?.points_value && (
                                  <div className="slider-row">
                                    <Slider3
                                      min={0}
                                      step={1}
                                      isDisabled={true}
                                      setValue={() => {}}
                                      value={pointsObj?.current_points}
                                      max={
                                        loyaltyData?.rewards?.[0]?.points_value
                                      }
                                    />
                                    <img
                                      alt="star"
                                      className="star"
                                      src="/assets/images/qr/others/star.svg"
                                    />
                                  </div>
                                )}
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {isAdvCbCreative ? (
                      <AdvancedLoyaltyFinalCreative
                        isShortlink={true}
                        pointsObj={pointsObj}
                        loyaltyData={loyaltyData}
                        storeName={qrCodeData?.entity_id?.name || ""}
                      />
                    ) : (
                      <LoyaltyFinalCreative
                        isShortlink={true}
                        pointsObj={pointsObj}
                        loyaltyData={loyaltyData}
                        storeName={qrCodeData?.entity_id?.name || ""}
                      />
                    )}
                    {isLoading && <Loading customClass={"component-loader"} />}
                  </div>
                ) : (
                  <></>
                )}
                {secondPageStatus !== "for_new_customer_only" && (
                  <>
                    <div className="redeem-dets">
                      <div className="left">
                        <Typography
                          size="text-sm"
                          weight="medium"
                          customClass="how-to-redeem"
                        >
                          How to redeem?
                        </Typography>
                        <Typography weight="medium" size="text-sm">
                          Give your mobile number to the staff on your next
                          purchase and ask them to redeem.
                        </Typography>
                      </div>
                      <Phone02 color={"#D9D6FE"} size={88.88} />
                    </div>
                    {data?.min_bill?.is_active ||
                    data?.storeWiseItemsList?.length > 1 ||
                    (data?.terms?.length > 0 &&
                      data?.terms?.split("\n")?.length > 0) ? (
                      <div className="terms-and-conditions">
                        <Typography size="text-sm" weight="medium">
                          Terms and Conditions
                        </Typography>
                        <ul>
                          {data?.min_bill?.is_active && (
                            <li>
                              Minimum purchase of {currencyView}
                              {data?.min_bill?.value} required to redeem reward.
                            </li>
                          )}
                          {data?.terms
                            ?.split("\n")
                            .map((term, i) =>
                              term?.length > 0 ? <li key={i}>{term}</li> : <></>
                            )}
                        </ul>
                        {data?.storeWiseItemsList?.length > 1 && (
                          <div className="qr-landing-page-terms-accordion">
                            <SbAccordion title="Discount valid on specific items">
                              <Typography size="text-xs">
                                {data?.storeWiseItemsList
                                  ?.map((item) => item.name)
                                  ?.join(" • ")}
                              </Typography>
                            </SbAccordion>
                          </div>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </>
            )}
            {isProfileCompleted && <ProfileDetails profileData={profileData} />}
          </div>
        ) : (
          <div className="enter-details-body">
            <Typography weight="medium" size="display-md">
              Enter your details &{" "}
              {isCheckCustRewardsObjective ? "check rewards!" : "claim it now!"}
            </Typography>
            {!(
              isBirthdayAnniversaryObjective || isCheckCustRewardsObjective
            ) && (
              <Input
                value={customerName}
                placeholder="Your Name"
                handleChange={(e) => setCustomerName(e.target.value)}
              />
            )}
            <Input
              type="number"
              value={customerPhone}
              placeholder="Your Phone Number"
              handleChange={(e) => setCustomerPhone(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth={true}
              disabled={isSubmitting}
              text={
                isCheckCustRewardsObjective
                  ? "Check reward"
                  : "Claim your reward"
              }
              isSubmitting={isSubmitting}
              handleClick={
                isBirthdayAnniversaryObjective
                  ? checkCustProfileStatus
                  : isCheckCustRewardsObjective
                  ? handleCheckCustomerRewards
                  : handleClaim
              }
              rightIcon={<ArrowNarrowLeft color="white" rotate={180} />}
            />
          </div>
        )}
      </div>
      <AllStoresCanvas
        data={data}
        isShortlink={true}
        isOpen={isAllStores}
        pointsObj={pointsObj}
        customerName={customerName}
        toggleCanvas={() => setIsAllStores(!isAllStores)}
      />
    </div>
  );
};

export default QrCodeLandingPage;
